import isItemView from '../utils/isItemView';
import { getListViewStore } from '../store/Store';
import { getMeetingClientItem } from './getMeetingClientItem';
import { logUsage } from 'owa-analytics';
import { RowInfoToGetRSVP } from 'mini-common-schema/lib/schema/RowInfoToGetRSVP';
import { setShouldShowRSVP } from '../actions/setShouldShowRSVP';

/**
 * This util check all the information of meeting invite needed to show the Rsvp in list view
 * and decide if we should show Rsvp in List view or not. For Ex - for past event don't show Rsvp
 * @param infoForRsvpCandidateRows list of mail list row with possible Rsvp unit
 */
export const handleLoadItemResponse = (infoForRsvpCandidateRows: RowInfoToGetRSVP[]) => {
    let rowsWithRsvpCount = 0;
    const { tableViews } = getListViewStore();

    infoForRsvpCandidateRows.forEach(rowInfo => {
        const { itemId, tableViewId, conversationId } = rowInfo;

        const showRSVP = !!getMeetingClientItem(itemId);
        const tableView = tableViews.get(tableViewId);

        isItemView(tableView)
            ? setShouldShowRSVP(tableViewId, itemId, showRSVP)
            : setShouldShowRSVP(tableViewId, conversationId, showRSVP);

        showRSVP && ++rowsWithRsvpCount;
    });

    const totalRsvpCandidateRows = infoForRsvpCandidateRows.length;
    logUsage('CalEvents2ListUIs', { S: rowsWithRsvpCount, T: totalRsvpCandidateRows });
};
